import { render, staticRenderFns } from "./recoveryRecord.vue?vue&type=template&id=e630e9e6"
import script from "./recoveryRecord.vue?vue&type=script&lang=js"
export * from "./recoveryRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports